document.addEventListener('DOMContentLoaded', function() {

  const searchWrapper = document.querySelector('.obw-blog__search');
  const searchBtn = document.querySelector('.obw-blog__search-btn');
  const searchInput = document.querySelector('.obw-blog__search-input');
  const listContainer = document.querySelector('.obw-blog__list-container');
  const config = window.OBW_BLOG_CONFIG || {};
  const blogHandle = config.blogHandle || '';
  const readMoreLabel = config.readMoreLabel || 'Weiterlesen';
  const emptyTitle = config.emptyTitle || 'Keine Artikel verfügbar.';
  const emptySubtitle = config.emptySubtitle || 'Bitte schauen Sie später noch einmal vorbei.';

  let searchTimeout = null;
  let abortController = null;

  /* Toggle search input slide */
  searchBtn.addEventListener('click', () => {
    searchWrapper.classList.toggle('active');
    if (searchWrapper.classList.contains('active')) {
      searchInput.focus();
    } else {
      searchInput.value = "";
      clearSearch();
    }
  });

  /* Live filtering with API call */
  searchInput.addEventListener('input', function() {
    const term = this.value.trim();
    
    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Abort previous request
    if (abortController) {
      abortController.abort();
    }

    // If search is empty, show original articles
    if (term === '') {
      clearSearch();
      return;
    }

    // Debounce API call
    searchTimeout = setTimeout(() => {
      searchArticles(term);
    }, 300);
  });

  function clearSearch() {
    // Hide loader
    hideLoader();

    // Show all original articles
    const articles = listContainer.querySelectorAll('.obw-blog__item:not(.obw-blog__search-item)');
    articles.forEach(article => {
      article.style.display = '';
    });
    
    // Show pagination if it exists
    const pagination = listContainer.querySelector('.obw-blog__pagination');
    if (pagination) {
      pagination.style.display = '';
    }

    // Remove search results container if exists
    const searchResults = listContainer.querySelector('.obw-blog__search-results');
    if (searchResults) {
      searchResults.remove();
    }

    // Remove empty state if exists
    const emptyState = listContainer.querySelector('.obw-blog__search-empty');
    if (emptyState) {
      emptyState.remove();
    }
  }

  async function searchArticles(searchTerm) {
    // Create new abort controller for this request
    abortController = new AbortController();

    // Show loader
    showLoader();

    try {
      // Build search URL - search for articles in the current blog
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const searchUrl = `${window.location.origin}${root}search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=article&resources[limit]=50`;

      const response = await fetch(searchUrl, {
        signal: abortController.signal
      });

      if (!response.ok) {
        throw new Error('Search request failed');
      }

      const data = await response.json();
      
      // Filter articles by current blog handle
      let articles = [];
      if (data.resources && data.resources.results && data.resources.results.articles) {
        articles = data.resources.results.articles.filter(article => {
          // Extract blog handle from article URL
          // URL format: /blogs/{blog-handle}/articles/{article-handle}
          const urlMatch = article.url.match(/\/blogs\/([^\/]+)\//);
          const articleBlogHandle = urlMatch ? urlMatch[1] : '';
          return articleBlogHandle === blogHandle;
        });
      }

      // Hide loader before showing results
      hideLoader();

      // Render search results
      if (articles.length > 0) {
        renderSearchResults(articles);
      } else {
        renderEmptyState();
      }

    } catch (error) {
      // Hide loader on error
      hideLoader();
      
      if (error.name === 'AbortError') {
        // Request was aborted, ignore
        return;
      }
      console.error('Search error:', error);
      // On error, show original articles
      clearSearch();
    }
  }

  function showLoader() {
    // Remove existing loader if any
    hideLoader();

    // Hide original articles and pagination
    const originalArticles = listContainer.querySelectorAll('.obw-blog__item:not(.obw-blog__search-item)');
    originalArticles.forEach(article => {
      article.style.display = 'none';
    });

    const pagination = listContainer.querySelector('.obw-blog__pagination');
    if (pagination) {
      pagination.style.display = 'none';
    }

    // Remove previous search results
    const existingResults = listContainer.querySelector('.obw-blog__search-results');
    if (existingResults) {
      existingResults.remove();
    }

    // Create and show loader
    const loader = document.createElement('div');
    loader.className = 'obw-blog__loader';
    loader.setAttribute('role', 'status');
    loader.setAttribute('aria-label', 'Loading search results');
    loader.innerHTML = `
      <div class="obw-blog__loader-spinner"></div>
    `;
    listContainer.appendChild(loader);
  }

  function hideLoader() {
    const loader = listContainer.querySelector('.obw-blog__loader');
    if (loader) {
      loader.remove();
    }
  }

  function renderSearchResults(articles) {
    const resultsContainer = document.createElement('div');
    resultsContainer.className = 'obw-blog__search-results';

    articles.forEach(article => {
      const articleElement = document.createElement('article');
      articleElement.className = 'obw-blog__item obw-blog__search-item';

      let html = '';

      // Article image - handle different possible formats
      const imageUrl = article.image || (article.image_url && article.image_url.src) || '';
      if (imageUrl) {
        html += `
          <figure class="obw-blog__item-image">
            <img
              src="${imageUrl}"
              alt="${escapeHtml(article.image_alt || article.title || '')}"
              loading="lazy"
            >
          </figure>
        `;
      }

      // Article title
      html += `
        <h3 class="obw-blog__item-title">
          ${escapeHtml(article.title)}
        </h3>
      `;

      // Article excerpt/description
      // The search API searches in both title and body content automatically
      const excerpt = article.body || article.summary || article.body_text || '';
      const cleanExcerpt = stripHtml(excerpt);
      const truncatedExcerpt = cleanExcerpt ? truncateWords(cleanExcerpt, 30) : '';
      
      if (truncatedExcerpt) {
        html += `
          <p class="obw-blog__item-excerpt">
            ${escapeHtml(truncatedExcerpt)}
          </p>
        `;
      }

      // Read more link
      html += `
        <a href="${article.url}" class="obw-blog__item-readmore">
          ${escapeHtml(readMoreLabel)}
        </a>
      `;

      articleElement.innerHTML = html;
      resultsContainer.appendChild(articleElement);
    });

    listContainer.appendChild(resultsContainer);
  }

  function renderEmptyState() {
    const emptyContainer = document.createElement('div');
    emptyContainer.className = 'obw-blog__empty obw-blog__search-empty';
    emptyContainer.setAttribute('role', 'status');
    emptyContainer.innerHTML = `
      <p>${escapeHtml(emptyTitle)}</p>
      <p>${escapeHtml(emptySubtitle)}</p>
    `;

    // Remove previous empty state
    const existingEmpty = listContainer.querySelector('.obw-blog__search-empty');
    if (existingEmpty) {
      existingEmpty.remove();
    }

    listContainer.appendChild(emptyContainer);
  }

  // Helper functions
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function stripHtml(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  function truncateWords(text, maxWords) {
    const words = text.trim().split(/\s+/);
    if (words.length <= maxWords) {
      return text;
    }
    return words.slice(0, maxWords).join(' ') + '...';
  }

});
